import React from "react";
import Box from "@material-ui/core/Box";
import NmLogo from "../nm_logo.png";
import AtokaLogo from "../atoka_logo.png";
import { Typography } from "@mui/material";
import { Other } from "../index";
import moment from "moment";

const lineSpace = "16px";

let securedParty;
let letterLogo;

const Clarification = (props) => {
	const {
		contract,
		applicant,
		street,
		city,
		state,
		zip,
		yourSincerely,
		selectedChangeTypes,
		otherTypeText,
		amendmentType,
		recordType,
	} = props;

	if (recordType === "NMEF") {
		securedParty = "North Mill Credit Trust";
		letterLogo = NmLogo;
	} else if (recordType === "Atoka") {
		securedParty = "Atoka Funding LLC";
		letterLogo = AtokaLogo;
	}

	return (
		<Box
			sx={{
				padding: "15px 30px",
				border: "1px solid #d6d6d6",
				boxShadow: "2px 4px 5px rgba(214, 214, 214, 0.75)",
			}}>
			{/* Logo */}
			<img src={letterLogo} style={{ width: 125 }} alt="" />
			<Box mt={2} mb={1}>
				<Typography>{moment().format("MM/DD/YYYY")}</Typography>
			</Box>
			<Box mb={1}>
				<Typography>{applicant}</Typography>
				<Typography>{street}</Typography>
				<Typography>
					{city}, {state}, {zip}
				</Typography>
			</Box>
			<Box mb={1}>
				<Typography>Contract # {contract}</Typography>
			</Box>
			<Box sx={{ marginTop: lineSpace }}>
				<Typography>Dear Sir/Madam,</Typography>
			</Box>
			<Box sx={{ marginTop: lineSpace }}>
				<Typography>This letter will serve as clarification to the:</Typography>
			</Box>
			<Box
				sx={{ marginTop: lineSpace, marginLeft: "24px", whiteSpace: "pre-wrap" }}>
				{selectedChangeTypes.map((changeType) => {
					const isOtherChangeTypeExists = changeType === Other;
					if (isOtherChangeTypeExists) {
						return (
							<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
								- {otherTypeText}
							</Typography>
						);
					}
					return (
						<Typography sx={{ whiteSpace: "pre-wrap" }} key={changeType}>
							- {changeType}
						</Typography>
					);
				})}
			</Box>
			<Box sx={{ marginTop: lineSpace }}>
				<Typography>
					All other terms and conditions of the contract remain the same.
				</Typography>
			</Box>
			<Box sx={{ marginTop: lineSpace }}>
				<Typography>
					<span style={{ fontWeight: "600" }}>
						Please retain this document for your records.
					</span>{" "}
					If you should have any questions concerning this change please feel free to
					call me at (203) 354-3654.
				</Typography>
			</Box>
			<Box sx={{ marginTop: "24px" }}>
				<Typography>Sincerely,</Typography>
			</Box>
			<Box sx={{ marginTop: lineSpace }}>
				<Typography>{yourSincerely}</Typography>
				<Typography>_________________</Typography>
				<Typography>Contract Administrator</Typography>
			</Box>
			<Box sx={{ marginTop: lineSpace }}>
				<Typography>{recordType}</Typography>
			</Box>
		</Box>
	);
};

export default Clarification;
